const customTheme = {
    light: {
        primary: '#fac904',
        accent: '#95AEE0',
        warning: '#FFBB33',
        secondary: '#FC3C3C',
        white: '#fff',
        success: '#66bb6a',
        dark: '#774e1e',
        rgbPrimaryLight: 'rgba(250, 201, 4,##)'
    },
    dark: {
        
        primary: '#e49314',
        accent: '#95AEE0',
        warning: '#FFBB33',
        secondary: '#FC3C3C',
        white: '#fff',
        success: '#66bb6a',
        dark: '#362d27',
        rgbPrimaryLight: 'rgba(250, 201, 4,##)'
    }
}


export default customTheme;